<template>
    <div>
        <v-col cols="12">
            <h2>{{ t('acl::page.title.acl-resource') }}</h2>
        </v-col>
        <v-col cols="12">
            <div class="form-wrapper">
                <v-form ref="form" v-model="isFormValid">
                    <div>
                        <v-row>
                            <v-col cols="12" lg="6" class="py-0">
                                <v-text-field
                                    v-model="route.name"
                                    :label="`${$root.defaultMandatoryAsteriks} ${t('acl::routes.edit.name')}`"
                                    :rules="[(v) => !!v || t('default::validation.field.required')]"
                                    dense
                                    background-color="#fff"
                                    outlined
                                    rounded
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" lg="6" class="py-0">
                                <v-switch
                                    v-model="route.allowed_for_all"
                                    :false-value="false"
                                    :label="
                                        route.allowed_for_all
                                            ? t('acl::routes.edit.allowed_for_all_groups')
                                            : t('acl::routes.edit.not_allowed_for_all_groups')
                                    "
                                    :true-value="true"
                                    class="mt-0"
                                >
                                </v-switch>
                            </v-col>
                            <v-col cols="12" lg="6" class="py-0">
                                <v-text-field
                                    v-model="route.tag"
                                    :label="`${$root.defaultMandatoryAsteriks} ${t('acl::routes.edit.tag')}`"
                                    :rules="[(v) => !!v || t('default::validation.field.required')]"
                                    dense
                                    background-color="#fff"
                                    outlined
                                    rounded
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" lg="6" class="py-0">
                                <v-switch
                                    v-model="route.visible_permission"
                                    :false-value="false"
                                    :label="
                                        route.visible_permission
                                            ? t('acl::routes.edit.visible_permission')
                                            : t('acl::routes.edit.not_visible_permission')
                                    "
                                    :true-value="true"
                                    class="mt-0"
                                >
                                </v-switch>
                            </v-col>
                            <v-col cols="12" lg="6" class="py-0">
                                <v-text-field
                                    v-model="route.system_name"
                                    :label="`${$root.defaultMandatoryAsteriks} ${t('acl::routes.edit.system_name')}`"
                                    :readonly="!!id"
                                    :rules="[(v) => !!v || t('default::validation.field.required')]"
                                    dense
                                    background-color="#fff"
                                    outlined
                                    rounded
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" lg="6" class="py-0">
                                <v-switch
                                    v-model="route.audit_disabled"
                                    :false-value="false"
                                    :label="
                                        route.audit_disabled
                                            ? t('acl::routes.edit.audit_disabled')
                                            : t('acl::routes.edit.not_audit_disabled')
                                    "
                                    :true-value="true"
                                    class="mt-0"
                                >
                                </v-switch>
                            </v-col>
                            <v-col cols="12" lg="6" class="pt-0">
                                <v-text-field
                                    v-model="route.uri"
                                    :label="`${$root.defaultMandatoryAsteriks} ${t('acl::routes.edit.uri')}`"
                                    :readonly="!!id"
                                    :rules="[(v) => !!v || t('default::validation.field.required')]"
                                    dense
                                    background-color="#fff"
                                    outlined
                                    rounded
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" lg="6" class="pt-0">
                                <div class="d-flex">
                                    <v-col class="py-0 pl-0">
                                        <v-switch
                                            v-model="route.allowed_for_guests"
                                            :disabled="!!id"
                                            :false-value="false"
                                            :label="
                                                route.allowed_for_guests
                                                    ? t('acl::routes.edit.allowed_for_guests')
                                                    : t('acl::routes.edit.not_allowed_for_guests')
                                            "
                                            :readonly="!!id"
                                            :true-value="true"
                                            class="mt-0"
                                        >
                                        </v-switch>
                                    </v-col>
                                    <v-col class="py-0 pl-0">
                                        <v-switch
                                            v-model="route.api_route"
                                            :disabled="!!id"
                                            :false-value="false"
                                            :label="
                                                route.api_route
                                                    ? t('acl::routes.edit.api_route')
                                                    : t('acl::routes.edit.not_api_route')
                                            "
                                            :readonly="!!id"
                                            :true-value="true"
                                            class="mt-0"
                                        >
                                        </v-switch>
                                    </v-col>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                    <b-form-actions
                        :id="id"
                        :back-route="$root.route('acl-routes.index')"
                        @discard="reset"
                        @save="save"
                    ></b-form-actions>
                </v-form>
            </div>
        </v-col>
    </div>
</template>

<script>
let formSubmitMixin = require(process.env.MIX_APP_ROOT +
    '/bgo/bgo-components/resources/js/mixins/FormSubmit.js').default;

export default {
    name: 'AclRouteFormComponent',
    mixins: [formSubmitMixin],
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            saveLoading: false,
            isFormValid: false,
            routeOriginal: null,
            route: {
                name: null,
                tag: null,
                system_name: null,
                uri: null,
                allowed_for_all: null,
                allowed_for_guests: null,
                api_route: null,
                visible_permission: null,
                audit_disabled: null,
            },
        };
    },
    created() {
        this.loadRoute();
    },
    methods: {
        loadRoute() {
            if (_.isEmpty(this.id)) {
                this.loading = false;
                return;
            }

            axios
                .get(route('api.v1.acl-routes.show', { acl_route: this.id }))
                .then((response) => {
                    this.route = response.data.data;
                    this.routeOriginal = _.clone(this.route);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        reset() {
            this.route = _.clone(this.routeOriginal);
        },
        save() {
            this.saveLoading = true;
            this.loading = true;

            this.submit(
                route('api.v1.acl-routes.update', {
                    acl_route: this.route.id,
                }),
                this.route,
                'put',
                () => {
                    this.$root.notify('info', t('default::notification.saved'));
                    this.$root.goTo(route('acl-routes.index'));
                }
            );
        },
    },
};
</script>
